import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { clientTaxiRatesAPI } from 'api/clientsTaxiRatesAPI';
import { TaxiRate } from 'api/vehicle/taxisRatesAPI.types';
import axios from 'axios';
import { clientsAPI } from '../api/clientsAPI';
import { BookingReference } from '../api/models/BookingReference';
import { Client } from '../api/models/Client';

export const getClients: any = createAsyncThunk(
  'clients/getClients',
  async (self, { rejectWithValue }) => {
    try {
      var clients: any = []
      const response = await clientsAPI.getClients()
      response.data.value.forEach((client: any) => {
        clients.push(new Client(client))
      })
      return clients
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getClientTravelPolicies: any = createAsyncThunk(
  'clients/getClientTravelPolicies',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await clientsAPI.getClientTravelPolicies(clientId)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getClientsByParentId: any = createAsyncThunk(
  'clients/getClientsByParentId',
  async (parentId, { rejectWithValue }) => {
    try {
      var clients: any = []
      const response = await clientsAPI.getClientsByParentId(parentId)
      response.data.value.forEach((client: any) => {
        clients.push(new Client(client))
      })
      return clients
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const updateClientUserProfile = async ({
  clientId,
  userProfile,
}: any) => {
  const updateResponse = await clientsAPI.updateClientUserProfile(
    clientId,
    userProfile.id,
    userProfile,
  )
  return updateResponse
}

//To be ran from anwhere to return a client from client ID.  This does not get saved in the store in clients.
export const getClient: any = createAsyncThunk(
  'clients/getClient',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await clientsAPI.getClient(clientId)

      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

//To be ran when the user logs in to create a client in the redux store
export const getUsersClient: any = createAsyncThunk(
  'clients/getUsersClient',
  async (clientId, { rejectWithValue }) => {
    try {
      const response = await clientsAPI.getClient()
      return new Client(response)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
      console.error(err)
      throw err
    }
  },
)

export const getBookingReferences: any = createAsyncThunk(
  'clients/getBookingReferences',
  async (clientId, { rejectWithValue }) => {
    try {
      var bookingReferences: any = []
      const response = await clientsAPI.getBookingReferences(clientId)
      response.data.value.forEach((bookingReference: any) => {
        bookingReferences.push(new BookingReference(bookingReference))
      })
      return bookingReferences
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)
const mapAddress = (address: any, type: any) => {
  if (address) {
    return {
      addressType: type,
      ...address,
    }
  }
  return undefined
}
export const createClient: any = createAsyncThunk(
  'clients/createClient',
  async (client: any, { rejectWithValue }) => {
    try {
      const primary = mapAddress(client.registration.address, 'Primary')
      const correspondence = mapAddress(
        client.contact.correspondenceAddress,
        'CorrespondenceAddress',
      )
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { ...registration } = client.registration
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { ...contact } = client.contact
      const newClient = {
        ...registration,
        parentClientId: registration.parentClientId
          ? registration.parentClientId.id
          : '',
        ...contact,
        billing: {
          billingTermTypeName: client.billing.billingTermTypeName,
          billingTermValue: client.billing.billingTermValue,
          accountNumber: client.billing.accountNumber,
          sortCode: client.billing.sortCode,
          vATRegistered: client.billing.vATRegistered,
          vATNumber: client.billing.vATNumber,
          currency: client.billing.currency,
        },
        // accountManager: client.registration.accountManager.value,
        // clientTypeName: client.registration.clientTypeName.value,
        addresses: [primary && primary, correspondence && correspondence],
        status: 'Onboarding',
      }
      const response = await clientsAPI.createClient(newClient)

      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const createBookingReference = createAsyncThunk(
  'clients/createBookingReference',
  async ({ clientId, bookingReference }: any, { rejectWithValue }) => {
    try {
      const response = await clientsAPI.createBookingReference(
        clientId,
        bookingReference,
      )
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const updateBookingReference = createAsyncThunk(
  'clients/updateBookingReference',
  async (
    { clientId, bookingReferenceId, bookingReference }: any,
    { rejectWithValue },
  ) => {
    try {
      const response = await clientsAPI.updateBookingReference(
        clientId,
        bookingReferenceId,
        bookingReference,
      )
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const deleteBookingReference = createAsyncThunk(
  'clients/deleteBookingReference',
  async ({ clientId, bookingReferenceId }: any, { rejectWithValue }) => {
    try {
      const response = await clientsAPI.deleteBookingReference(
        clientId,
        bookingReferenceId,
      )
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const createClientTaxiRates = createAsyncThunk(
  'clients/createClientTaxiRates',
  async (
    { data, clientId }: { data: TaxiRate; clientId: number },
    { rejectWithValue }: { rejectWithValue: (value: any) => void },
  ) => {
    console.log('createClientTaxiRates - Reducer: Data', data)
    try {
      const response = await clientTaxiRatesAPI.createTaxiRates(data, clientId)
      console.log('createClientTaxiRates response', response)
      return response
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getClientTaxiRates = createAsyncThunk(
  'clients/getClientTaxiRates',
  async (
    clientId: number,
    { rejectWithValue }: { rejectWithValue: (value: any) => void },
  ) => {
    try {
      const response = await clientTaxiRatesAPI.getTaxiRates(clientId)
      // console.log('getClientTaxiRates response', response)
      return response.data
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const getClientTaxiRatesById = createAsyncThunk(
  'clients/getClientTaxiRatesById',
  async (
    { clientId, taxiRateId }: { clientId: number; taxiRateId: number },
    { rejectWithValue }: { rejectWithValue: (value: any) => void },
  ) => {
    try {
      const response = await clientTaxiRatesAPI.getTaxiRateById(
        clientId,
        taxiRateId,
      )
      return response.data
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

export const updateClientTaxiRatesById = createAsyncThunk(
  'clients/updateClientTaxiRatesById',
  async (
    {
      clientId,
      taxiRateId,
      data,
    }: { clientId: number; taxiRateId: number; data: TaxiRate },
    { rejectWithValue }: { rejectWithValue: (value: any) => void },
  ) => {
    try {
      const response = await clientTaxiRatesAPI.updateTaxiRateById(
        clientId,
        taxiRateId,
        data,
      )

      return response.data
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)

const clientsSlice = createSlice({
  name: 'clients',
  initialState: {
    error: null,
    registration: undefined,
    contact: undefined,
    billing: undefined,
    client: undefined,
    selectedClient: undefined,
  },
  reducers: {
    createRegistration(state, action) {
      const newState = {
        ...action.payload,
      }
      state.registration = newState
    },
    createContact(state, action) {
      const newState = {
        ...action.payload,
      }
      state.contact = newState
    },
    createBilling(state, action) {
      const newState = {
        ...action.payload,
      }
      state.billing = newState
    },
    resetClientStore(state) {
      state.error = null
      state.registration = undefined
      state.contact = undefined
      state.billing = undefined
      state.selectedClient = undefined
      state.client = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsersClient.fulfilled, (state: any, action) => {
      state.client = action.payload
    })

    builder.addCase(getClientsByParentId.rejected, (state: any, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(getClient.rejected, (state: any, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(getClient.fulfilled, (state: any, action) => {
      state.selectedClient = action.payload
    })
    builder.addCase(getBookingReferences.rejected, (state: any, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
    builder.addCase(createClient.rejected, (state: any, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
  },
})

export const {
  createRegistration,
  createContact,
  createBilling,
  resetClientStore,
} = clientsSlice.actions

export default clientsSlice.reducer
